import api from '../api';

import { ParamsDataGenerateBillingDefault } from 'utils/typeServices';

type ParamsResponse = {
    Data: ParamsDataGenerateBillingDefault;
}

export const PostGenerateBilling = async ({ token, CHAVE_PAGAMENTO, ISPIX, EMAIL, CD_FORMA_PAGAMENTO }: { token: string, CHAVE_PAGAMENTO: string; ISPIX: boolean; EMAIL?: string, CD_FORMA_PAGAMENTO?: number; }) => {
    const bodyJson = JSON.stringify({ CHAVE_PAGAMENTO, ISPIX, EMAIL, CD_FORMA_PAGAMENTO });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Pagamento/GerarCobranca', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
